export var ShopAction;
(function (ShopAction) {
    ShopAction["CART_CREATION"] = "cart.creation";
    ShopAction["ORDER_CREATION"] = "order.creation";
})(ShopAction || (ShopAction = {}));
export var WebhookType;
(function (WebhookType) {
    WebhookType["INCOMING"] = "incoming";
    WebhookType["OUTGOING"] = "outgoing";
})(WebhookType || (WebhookType = {}));
export var WebhookSite;
(function (WebhookSite) {
    WebhookSite["INTERNAL"] = "internal";
    WebhookSite["USPACY"] = "uspacy";
})(WebhookSite || (WebhookSite = {}));
